import React, { useState } from "react"
import AdminProfileBlock from "components/shared/AdminProfileBlock"
import { AdminProfileType } from "services/api-service/types"
import styled from "styled-components"
import { Box, Row } from "ui/components/atoms/_atoms"
import Spinner from "ui/components/atoms/spinner"

const ProfilesList = ({ loading, data }: { loading: boolean; data: AdminProfileType[] }) => {
  const [edit, setEdit] = useState<AdminProfileType | boolean>(false)

  if (loading)
    return (
      <Wrapper>
        <Row $justifyContent="center">
          <Spinner $size="30px" />
        </Row>
      </Wrapper>
    )

  return (
    <Wrapper>
      {data.map(el => (
        <AdminProfileBlock key={el.id} data={el} />
      ))}
    </Wrapper>
  )
}

export default ProfilesList

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  grid-gap: ${({ theme }) => theme.space.XS};
`
